import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { Provider } from "@redotech/redo-order-common/provider";
import { getProviderDisplayName } from "@redotech/redo-order-core-common/order";

function getOrderSource(orderSources: Provider[]) {
  const first = orderSources[0];
  if (!first) {
    return "";
  }
  if (orderSources.some((source) => source !== first)) {
    return "Mixed";
  }
  return getProviderDisplayName(first);
}

export const OrderSourceCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  { header: "Order Source", cell: (row) => getOrderSource(row.orderSources) };
